// import { iBigModelSceneInfo } from '@/documentModel/docBigModel';

const headerH = 89;
const keys: any = [
  'titleGenerator',
  'agendaSummary',
  'roleSummary',
  'pptExtractor',
  'qaReview',
  'qaKeyPoint',
  'actionExtractor',
];

export { headerH, keys };
